export const formatDate = (date: Date | null) => {
	if (!date) return 'Selecione'
	return date.toLocaleDateString('pt-br', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	})
}
